
const sizeField = "Size";

export default {
  props: {
    options: { type: Array, default: () => [] },
    handle: { type: String, default: "" },
  },

  data: () => ({
    openTooltip: false,
  }),

  computed: {
    sizes() {
      return (
        this.options
          .find(option => option.name === sizeField)
          ?.optionValues.map(optionValue => optionValue.name) ?? []
      );
    },
    sizesLabel() {
      return this.sizes.length
        ? `${this.sizes.length} ${this.sizes.length == 1 ? "size" : "sizes"}`
        : null;
    },
  },
};
